import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactToPrint from 'react-to-print';
import Moment from 'react-moment';
import PlaceHolder from '../../../assets/images/loading.gif';
import Template from '../../../components/Template/AfterLoginTemplate';
import ResumeParticipantContent from '../../../components/Parts/ResumeParticipantContent';
import PlaceHolderImg2x from '../../../assets/images/placeholder@2x.png';
// import PlaceHolderImg2x from "../../../assets/images/vert.jpg";
// import PlaceHolderImg2x from "../../../assets/images/hori.png";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.userData = this.props.Task.participantDetail;
    console.log(
      'TCL: Component -> constructor -> this.userData',
      this.props.Task.participantDetail
    );
    this.taskData = this.props.Task.taskDetail;
    this.state = {
      openCheck: false,
      closeCheck: true,
      type: '1',
      mail: '',
      description: ''
    };
  }

  //  eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.taskrews_id;
    console.log(this.props.Task.participantDetail);
    console.log(this.props.Task.taskDetail);
  };

  goBack = () => {
    // console.log(this.props);
    this.props.history.goBack();
  };

  _renderImage = () => {
    if (!this.userData.photoId) {
      return <img className="img" alt="" src={PlaceHolderImg2x} />;
    }
    return <img alt="" className="img" src={this.userData.photoId} />;
  };

  _renderSex = () => {
    if (this.userData.sex === '女性') {
      return (
        <div className="row">
          <div className="col-6 center ">
            <div className="">
              <p>男</p>
            </div>
          </div>
          <div className="col-6 center">
            <div className="circle">
              <p>女</p>
            </div>
          </div>
        </div>
      );
    }
    if (this.userData.sex === '男性') {
      return (
        <div className="row">
          <div className="col-6 center ">
            <div className="circle">
              <p>男</p>
            </div>
          </div>
          <div className="col-6 center">
            <div className="">
              <p>女</p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-6 center ">
          <div className="">
            <p>男</p>
          </div>
        </div>
        <div className="col-6 center">
          <div className="">
            <p>女</p>
          </div>
        </div>
      </div>
    );
  };

  _renderDescription = () => {
    let desc = this.description;
    const descMaxSize = 200;
    if (!!desc && desc.length > descMaxSize) {
      desc = desc.slice(0, descMaxSize);
      desc += '...';
    }
    return desc;
  };

  _renderTaskTitle = () => {
    const { title } = this.taskData;
    const { taskId } = this.taskData;
    let value = '';
    if (taskId) {
      value = `<span className='taskid'>${taskId}</span>`;
    }
    if (title) {
      value = `${value}< span className = 'title' >${title}</span > `;
    }

    return (
      <span>
        <span className="taskid">{taskId}</span>
        <h3 className="title">{title}</h3>
      </span>
    );
  };

  _renderPhone = () => {
    let { phone } = this.userData;
    if (phone) {
      phone = phone.replace('+81', '0');
    }
    return phone;
  };

  _renderGraduation = () => {
    return (
      <div>
        <sapn>
          {this.userData.graduateYear}年{this.userData.graduateMonth}月卒業
        </sapn>
        <span className="graduation">{this.userData.graduation}</span>
      </div>
    );
  };

  render = () => {
    return (
      <Template>
        <div>
          <div className="resume_layout">
            <div className="display_none">
              <ResumeParticipantContent
                ref={el => (this.componentRef = el)}
                userData={this.props.Task.participantDetail}
                taskData={this.props.Task.taskDetail}
              />
            </div>
            <div className="resume">
              <div className="part1">
                <div className="title p_tb_10">
                  taskell 履歴書 <span className="b_name">({this.currentUser.enterpriseName})</span>
                </div>
                <div className="date p_tb_10 col-9">
                  <Moment date={this.currentDate} tz="Asia/Tokyo" format="YYYY/MM/DD" />
                </div>
                <div className="subpart1 row">
                  <div className="col-9">
                    <div className="na_br_ge">
                      <div className="div_kana row">
                        <div className="hirakana col-2 p_tb_10 center subtitle">フリガナ</div>
                        <div className="hira_value col-10 p_tb_10 ">
                          {this.userData.lastNameKana}
                          {'  '}
                          {this.userData.fastNameKana}
                        </div>
                      </div>
                      <div className="div_name row">
                        <div className="name col-2 p_tb_10 center subtitle">氏名</div>
                        <div className="name_value col-10 p_tb_10">
                          {this.userData.lastName}
                          {'  '}
                          {this.userData.fastName}
                        </div>
                      </div>
                      <div className="birth_sex row">
                        <div className="name col-2 p_tb_10 center subtitle">生年月日</div>
                        <div className="birth col-5 p_tb_10 ">
                          <p className="birth_value">
                            {this.userData.birthyear} 年{this.userData.birthmonth} 月
                            {this.userData.birthday} 日<span className="at">生</span>(
                            {this.userData.age}
                            歳)
                          </p>
                        </div>
                        <div className="name col-2 p_tb_10 center subtitle">性別</div>
                        <div className="sex col-3 p_tb_10">{this._renderSex()}</div>
                      </div>
                      <div className="phone_email row">
                        <div className="name col-2 p_tb_10 center subtitle">メール</div>
                        <div className="email col-5 p_tb_10 ">{this.userData.email}</div>
                        <div className="name col-2 p_tb_10 center subtitle">電話</div>
                        <div className="phone col-3 p_tb_10">{this._renderPhone()}</div>
                      </div>
                      <div className="address row">
                        <div className="name col-2 p_tb_10 center subtitle">現住所</div>
                        <div className="value col-10 p_tb_10 ">
                          {this.userData.postalcode}
                          <span>
                            {' '}
                            {this.userData.prefecture}
                            {this.userData.municipality}
                            {this.userData.street}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 photo">
                    <div className="square">{this._renderImage()}</div>
                  </div>
                </div>
              </div>
              <div className="part2-1 row">
                <div className="label col-12 p_tb_10 center subtitle">最終学歴</div>
                <div className="content col-12 p_tb_10">{this._renderGraduation()}</div>
              </div>
              <div className="part2 row">
                <div className="label col-12 p_tb_10 center subtitle">保有資格</div>
                <div className="content col-12 p_tb_10">
                  <p>
                    {(() => {
                      if (this.userData.licenseDetail && this.userData.licenseDetail.length > 0) {
                        return this.userData.licenseDetail.map((license, i) => {
                          const last = i + 1 === this.userData.licenseDetail.length;
                          let text;
                          if (last) {
                            text = license.value;
                          } else {
                            text = `${license.value} /`;
                          }
                          return <span key={i}>{text}</span>;
                        });
                      }
                      return <span>-</span>;
                    })()}
                  </p>
                </div>
              </div>
              <div className="part2-3 row">
                <div className="label col-12 p_tb_10 center subtitle">タスク</div>
                <div className="content col-12 resume-task">
                  <h2>タスクID:{this._renderTaskTitle()}</h2>
                  <h4>
                    タスク実施日時: {this.taskData.startDate}
                    <span>{this.taskData.workingHours}</span>
                  </h4>
                </div>
              </div>
              <div className="part3 row">
                <div className="label col-12 p_tb_10 center subtitle">自己紹介／備考等</div>
                <div className="content col-12 p_tb_10">{this.userData.selfIntintroduction}</div>
              </div>
              <div className="part4 row">
                <div className="col-12 p_tb_10">
                  <p>
                    本書は介護施設事業者がtaskellを通して募集した特定タスクへの応募者のプロフィール情報を利用して生成しています。応募者は簡易履歴書の生成利用に同意しています。本履歴書は介護事業者の便宜のために提供されるものであり、taskellはその内容の正確性については一切責任を負いかねますのでご了承ください。
                  </p>
                </div>
              </div>
            </div>
            <div className="resume-button">
              <div className="col-sm-4" />
              <div className="col-sm-4 center">
                <button
                  type="button"
                  className="btn btn-primary"
                >
                  <ReactToPrint
                    trigger={() => <a href="#">履歴書を出力する </a>}
                    content={() => this.componentRef}
                  />
                </button>
              </div>
              <div className="col-sm-4 center">
                <button
                  type="button"
                  onClick={this.goBack}
                  className="btn btn-primary"
                >
                  戻る
                </button>
              </div>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
// const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(
  mapStateToProps
  //   mapDispatchToProps
)(Component);

export default withRouter(Container);

// ReactDOM.render(<App />, document.getElementById("root"));
